;(function () {

"use strict";

function resize() {
  var max = -1000;
  var $addresses = $('.addresses > li.address');

  $addresses.each(function () {
    var h = $(this).css('height', '').height();
    if (h > max) {
      max = h;
    }
  });

  $addresses.height(max);
}

var PageView = Backbone.View.extend({
  initialize: function () {
    // this.$el.find('.address .form-vertical')
    $(window).on('resize', resize);
    resize();
  },
  editAddress: function (e) {
  }
});

module.exports = PageView;

}());